module.exports = __webpack_public_path__ + "static/media/primero_lee_logo.60564138.bin";